import { Instance, types as t } from 'mobx-state-tree';
import {
  DiagramLabelCompletion,
  VoidBlankSnapshotIn,
} from '../../../question-data-model/Question/_implementations/diagram-label-completion.store';
import { ExtraQuestionProps } from '../../components/questions/BaseQuestion';
import { ResultTestQuestionStore } from '../result-test-question.store';

export interface DiagramLabelExtraQuestionProps extends ExtraQuestionProps {
  blanks?: VoidBlankSnapshotIn[];
  baseNo?: number;
  scroll?: boolean;
}

export const ResultDiagramLabelQuestion = t
  .compose(ResultTestQuestionStore, DiagramLabelCompletion)
  .named('ResultDiagramLabelQuestion')
  .views((self) => ({
    get questionCount() {
      return self.correctAnswers.length;
    },
    getQuestions() {
      return self.correctAnswers.map((correctAnswer, index) => {
        const userAnswer = self.userAnswers.find((_, uaIndex) => uaIndex === index);
        const extraProps: DiagramLabelExtraQuestionProps = {
          no: self.no + index,
          correction: correctAnswer,
          markedStatus: self.marked[index],
          userAnswer,
          corrections: self.correctAnswers,
          index,
          baseNo: self.no,
          blanks: self.getBlanksFromNodeBlanks(),
          userAnswerKey: userAnswer?.userAnswer,
          correctAnswerKey: correctAnswer.value,
          scroll: false,
        };
        return {
          ...self,
          ...extraProps,
        };
      });
    },
  }));

export interface ResultDiagramLabelQuestionInstance
  extends Instance<typeof ResultDiagramLabelQuestion> {}
